import React from 'react'
import HeroV2, { HeroV2Props } from '../HeroV2/HeroV2'
import CarouselV2, { CarouselV2Props } from '../../elements/CarouselV2/CarouselV2'
import cx from 'classnames'
import styles from './HeroCarousel.module.scss'
import { CarouselCard } from '~elements'
import { CarouselCardProps } from 'components/elements/CarouselCard/CarouselCard'

export interface HeroCarouselProps<T extends CarouselCardProps> {
  alignHeadline?: 'center' | 'bottom'
  // HeroV2 props
  hero: HeroV2Props
  // CarouselV2 props
  carousel: CarouselV2Props<T>
}
function HeroCarousel<T extends CarouselCardProps>({
  alignHeadline,
  hero: { description, responsiveMultimedia, subtitle, title, showTitle, justify, ctaButtons },
  carousel: {
    slides: carouselSlides,
    className: carouselClassName,
    allShowsUrl,
    enableGlobalKeyboard,
    showAllShowsButton
  }
}: HeroCarouselProps<T>) {
  return (
    <div className={styles['hero-carousel-module']} data-testid='hero-carousel-module'>
      <div className={styles['hero-carousel-hero']}>
        <HeroV2
          alignHeadline={alignHeadline}
          description={description}
          responsiveMultimedia={responsiveMultimedia}
          subtitle={subtitle}
          title={title}
          showTitle={showTitle}
          justify={justify}
          ctaButtons={ctaButtons}
          isChildOfHeroCarousel={true}
        />
      </div>
      <div
        className={cx(
          styles['hero-carousel-carousel'],
          alignHeadline === 'bottom' && styles['hero-carousel-carousel__bottom-align']
        )}
      >
        <CarouselV2
          slides={carouselSlides}
          className={carouselClassName}
          allShowsUrl={allShowsUrl}
          enableGlobalKeyboard={enableGlobalKeyboard}
          showArrowsBreakpointUp='md'
          showAllShowsButton={showAllShowsButton}
          useCustomSlideCalculation={true}
          useScrollSliderBelowBreakpoint='md'
          renderSlide={(slide: CarouselCardProps, index) => (
            <CarouselCard key={index} {...slide} tabIndex={0} isChildOfHeroCarousel={true} />
          )}
        />
      </div>
    </div>
  )
}

export default HeroCarousel
